import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/productHome.vue"),
  },
  {
    path: "/home",
    component: () => import("../views/productHome.vue"),
  },
  {
    path: "/perProduct",
    component: () => import("../components/per-product.vue"),
  },
  {
    path: "/product",
    component: () => import("../views/product.vue"),
  },
  {
    path: "/login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/register",
    component: () => import("../views/register.vue"),
  },
  {
    path: "/password",
    component: () => import("../views/password.vue"),
  },
  {
    path: "/bijiao",
    component: () => import("../views/bijiao.vue"),
  },
  {
    path: "/semiconductor",
    component: () => import("../views/semiconductor.vue"),
  },
  {
    path: "/personal",
    component: () => import("../views/personal.vue"),
    children: [
      {
        path: "",
        component: () => import("../components/per-acc.vue"),
      },
      {
        path: "acc",
        component: () => import("../components/per-acc.vue"),
      },
      {
        path: "order",
        component: () => import("../components/per-order.vue"),
      },
      {
        path: "xiang",
        component: () => import("../components/per-order-xiang.vue"),
      },
      {
        path: "car",
        component: () => import("../components/per-car.vue"),
      },
      {
        path: "pwd",
        component: () => import("../components/per-pwd.vue"),
      },
      {
        path: "msg",
        component: () => import("../components/per-msg.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(function(to, from, next) {
  if (
    to.path == "/login" ||
    to.path == "/bijiao" ||
    to.path == "/home" ||
    to.path == "/register" ||
    to.path == "/" ||
    to.path == "/password" ||
    to.path == "/productHome" ||
    to.path == "/product" ||
    to.path == "/perProduct" ||
    to.path == '/semiconductor'||
    to.path == "/register"
  ) {
    next();
  } else if (window.sessionStorage.getItem("Authorization")) {
    // 获取localStorage中保存的数据    
    const oldClickItem = JSON.parse(sessionStorage.getItem("oldClickItem"));
    const oldClickIndex = JSON.parse(sessionStorage.getItem("oldClickIndex"));
    const oldClick2Item = JSON.parse(sessionStorage.getItem("oldClick2Item"));
    // 将数据赋值给Vue实例的data属性    
    if (oldClickItem && oldClickIndex) {
      Vue.prototype.$data.list1 = oldClickItem;
      Vue.prototype.$data.clickact1 = oldClickItem[oldClickIndex[oldClickIndex.length - 1]].val;
      Vue.prototype.$data.list1Name = "·" + oldClickItem[oldClickIndex[oldClickIndex.length - 1]].name;
      Vue.prototype.$data.list1NameEn = "·" + oldClickItem[oldClickIndex[oldClickIndex.length - 1]].nameEn;
    }
    if (oldClick2Item) {
      Vue.prototype.$data.list2Name = "·" + oldClick2Item.name;
      Vue.prototype.$data.list2NameEn = "·" + oldClick2Item.nameEn;
      Vue.prototype.$data.clickact2 = oldClick2Item.val;
    }
    next();
  } else {
    next("/login");
  }
});

export default router;